import { serverRouteHandlers } from '@online-webinar/router/src/handlers';
import { RouterType } from '@online-webinar/router/src/router';
import { createServerOnlyFn } from '@tanstack/react-start';
import fs from 'fs';
import defaultTheme from '../../public/themes/default-theme.css?inline';
let themeCache: string | null = null;

const updateServerRoute = createServerOnlyFn(() => {
    serverRouteHandlers.theme = async () => {
        if (process.env.VITE_IS_WHITELABEL !== 'true') {
            return new Response(defaultTheme, { headers: { 'Content-Type': 'text/css' } });
        }

        if (themeCache && process.env.VITE_IS_PRODUCTION === 'true') {
            return new Response(themeCache, { headers: { 'Content-Type': 'text/css' } });
        }

        let themePath = `${process.env.VITE_PUBLIC_PATH}/themes/${process.env.VITE_SITE_CODE?.toLocaleLowerCase()}.css`;
        if (fs.existsSync(themePath)) {
            themeCache = fs.readFileSync(themePath, 'utf-8');
        } else {
            themeCache = defaultTheme;
        }

        return new Response(themeCache, { headers: { 'Content-Type': 'text/css' } });
    };
});

export const updateRoute = (router: RouterType) => {
    if (import.meta.env.SSR) {
        updateServerRoute();
    }
};
